import { h, Host } from "@stencil/core";
import { calculateValue, getNumberValue, getValidatedValue } from "./number-input-utils";
const baseClass = "ux-number-input";
let id = 0;
export class NumberInput {
    constructor() {
        this.name = "";
        this.value = undefined;
        this.initialValue = undefined;
        this.step = "1";
        this.max = "";
        this.min = "";
        this.label = "";
        this.labelInfo = "";
        this.disabled = false;
        this.required = false;
        this.error = false;
        this.errorMsg = null;
        this.inputId = "";
        this.fullWidth = false;
        this.disabledMinusButton = false;
        this.currentValue = undefined;
        this.minValue = undefined;
        this.maxValue = undefined;
        this.stepValue = undefined;
    }
    inputElement;
    domNode;
    componentWillLoad() {
        // @ts-expect-error Check for typing
        const initialValue = !isNaN(getNumberValue(this.initialValue)) ? this.initialValue : this.value;
        // @ts-expect-error Check for typing
        const initialNumber = +initialValue;
        this.currentValue = !isNaN(initialNumber) ? initialNumber : 0;
        this.setNumbers();
        if (this.inputId === "") {
            this.inputId = `${baseClass}-id-${id++}`;
        }
    }
    /** Emitted when the value has changed. */
    numberInputChange;
    setNumbers() {
        const { max, min, step } = this;
        // @ts-expect-error Check for typing
        this.minValue = getNumberValue(min);
        // @ts-expect-error Check for typing
        this.maxValue = getNumberValue(max);
        // @ts-expect-error Check for typing
        const stepValue = getNumberValue(step);
        this.stepValue = isNaN(stepValue) ? 1 : stepValue;
    }
    handlePlus() {
        this.changeValue("increment");
    }
    handleMinus() {
        this.changeValue("decrement");
    }
    changeValue(type = "increment") {
        const { stepValue, maxValue, minValue, currentValue } = this;
        this.currentValue = calculateValue(type, currentValue, stepValue, maxValue, minValue);
        this.inputElement.value = this.currentValue.toString();
        this.numberInputChange.emit({
            currentValue: this.currentValue,
            inputName: this.name,
            inputId: this.inputId
        });
    }
    onChange(event) {
        const { maxValue, minValue, currentValue } = this;
        const { value } = event.target;
        this.currentValue = getValidatedValue(value, currentValue, maxValue, minValue);
        this.inputElement.value = this.currentValue.toString();
        this.numberInputChange.emit({
            currentValue: this.currentValue,
            inputName: this.name,
            inputId: this.inputId
        });
    }
    minusButtonDisabled() {
        return this.disabledMinusButton && this.minValue === this.currentValue;
    }
    render() {
        const { name, max, min, stepValue, currentValue, label, labelInfo, disabled, required, error, errorMsg, inputId, fullWidth } = this;
        return (h(Host, { key: '966d6c506b574d9ba8f2f8749e94e6987b1cda29', class: {
                [baseClass]: true,
                [`${baseClass}--disabled`]: disabled,
                [`${baseClass}--error`]: error,
                [`${baseClass}--full-width`]: fullWidth
            } }, h("ux-input-label", { key: 'd684513034a9a7223abffab5b539430302cb1fdf', text: label, labelClasses: `${baseClass}__label`, inputId: inputId, error: error,
            // @ts-expect-error Check for typing
            errorMsg: errorMsg, required: required, labelInfo: labelInfo }, h("slot", { key: '52314e0b2843e0987fc204433b824abd50fcd42a' })), h("div", { key: 'ff420af1becbf780929d5904c38b090eda4a265d' }, h("div", { key: '10b02144c212901c29706c3dcc812069c613b79b', class: `${baseClass}__wrapper` }, h("button", { key: '66cea927bbf616640801ddc97cb239b1e7f4f239', type: "button", class: {
                [`${baseClass}__btn`]: true,
                [`${baseClass}__btn--disabled`]: this.minusButtonDisabled()
            }, onClick: () => this.handleMinus() }, "\u2013"), h("input", { key: '617e8b69f0c14406c843a391223f71ae5ff33e76', class: `${baseClass}__input`, name: name, step: stepValue.toString(), type: "number", id: inputId, max: max, min: min, value: currentValue,
            // @ts-expect-error Check for typing
            ref: (el) => (this.inputElement = el), onInput: (event) => this.onChange(event), "aria-invalid": error ? "true" : "false" }), h("button", { key: 'f6991d9d4ddbe880176ba9b36ed28285802d6683', type: "button", class: `${baseClass}__btn`, onClick: () => this.handlePlus() }, "+")), h("div", { key: 'b873692f4545857cb121ec378add41d4aa8cc2d0', class: `${baseClass}__slot` }, h("slot", { key: '0f5892515be6acf692951524ee45f83552d8eaa3' })))));
    }
    static get is() { return "ux-number-input"; }
    static get originalStyleUrls() {
        return {
            "$": ["number-input.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["number-input.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "name attribute for the input"
                },
                "attribute": "name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "initial value for the input"
                },
                "attribute": "value",
                "reflect": false
            },
            "initialValue": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [{
                            "name": "deprecated",
                            "text": "use value instead"
                        }],
                    "text": ""
                },
                "attribute": "initial-value",
                "reflect": false
            },
            "step": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "size of increment/decrement for the plus/minus button"
                },
                "attribute": "step",
                "reflect": false,
                "defaultValue": "\"1\""
            },
            "max": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "max value"
                },
                "attribute": "max",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "min": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "min value"
                },
                "attribute": "min",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Label text describing the number input field"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "labelInfo": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "additional info label for the the input field"
                },
                "attribute": "label-info",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the number input is disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the number input is required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the number input has an error state"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "errorMsg": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "null | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Error message that is rendered if component has an error"
                },
                "attribute": "error-msg",
                "reflect": false,
                "defaultValue": "null"
            },
            "inputId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "id attribute for the input element, this will be set automatically if it is not set by the developer"
                },
                "attribute": "input-id",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "fullWidth": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the component should occupy the full container width"
                },
                "attribute": "full-width",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabledMinusButton": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the minus button is disabled when reaching the min value"
                },
                "attribute": "disabled-minus-button",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "currentValue": {},
            "minValue": {},
            "maxValue": {},
            "stepValue": {}
        };
    }
    static get events() {
        return [{
                "method": "numberInputChange",
                "name": "uxNumberInputChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the value has changed."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "domNode"; }
    static get watchers() {
        return [{
                "propName": "min",
                "methodName": "setNumbers"
            }, {
                "propName": "max",
                "methodName": "setNumbers"
            }, {
                "propName": "step",
                "methodName": "setNumbers"
            }];
    }
}
//# sourceMappingURL=number-input.js.map
